<template>
  <b-navbar v-if="isLoggedIn" shadow wrapper-class="container is-max-hd">
    <template #brand>
      <b-navbar-item tag="router-link" :to="{ path: '/' }">
        <img style="margin-bottom: -6px" src="/static/logo-wide.png" />
      </b-navbar-item>
    </template>
    <template #start>
      <b-navbar-item class="nav-item">
        <router-link
          :to="{ name: 'InquiryList' }"
          class="nav-link"
          :class="{ 'is-active': isInquiriesActive }"
        >
          <b-icon icon="magnify" class="mr-2"></b-icon>
          Inquiries
        </router-link>
      </b-navbar-item>
      <b-navbar-item class="nav-item">
        <router-link
          :to="{ name: 'InsuranceDiscoveryList' }"
          class="nav-link"
          :class="{ 'is-active': isInsuranceDiscoveryActive }"
        >
          <b-icon icon="card-account-details" class="mr-2"></b-icon>
          Blanket VOB Search
        </router-link>
      </b-navbar-item>
    </template>

    <template #end>
      <b-navbar-dropdown v-if="isLoggedIn" right :label="user.email">
        <div v-if="isAdmin">
          <b-navbar-item tag="router-link" :to="{ name: 'AdminIndex' }">
            <strong>Admin</strong>
          </b-navbar-item>
          <hr />
        </div>
        <div v-if="isManager">
          <b-navbar-item tag="router-link" :to="{ name: 'OrganizationDetail' }">
            Organization Settings
          </b-navbar-item>
        </div>
        <b-navbar-item tag="router-link" :to="{ name: 'ProfileDetail' }">
          Profile Settings
        </b-navbar-item>
        <b-navbar-item tag="a" href="mailto:support@quickadmit.com">Email Support</b-navbar-item>
        <b-navbar-item tag="router-link" :to="{ name: 'TermsAndConditions' }">Terms</b-navbar-item>
        <hr />
        <b-navbar-item @click="logout">Logout</b-navbar-item>
      </b-navbar-dropdown>
      <div class="buttons" v-if="!isLoggedIn">
        <b-navbar-item tag="div">
          <b-button type="is-primary" tag="router-link" :to="{ name: 'Login' }">Login</b-button>
          <b-button type="is-secondary" tag="router-link" :to="{ name: 'Register' }">
            Register
          </b-button>
        </b-navbar-item>
      </div>
    </template>
  </b-navbar>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'Nav',
  computed: {
    ...mapGetters(['isLoggedIn', 'isAdmin', 'isManager', 'user']),
    isInquiriesActive() {
      return this.$route.path.includes('inquiries');
    },
    isInsuranceDiscoveryActive() {
      return this.$route.path.includes('blanket-vob-search');
    },
  },
  methods: {
    logout() {
      this.$store.dispatch('logout');
    },
  },
};
</script>

<style scoped>
hr {
  margin: 0.5rem 0;
}

.nav-item {
  padding: 0 !important;
  margin: 0 !important;
  height: 100% !important;
}

.nav-link {
  display: flex;
  align-items: center;
  padding: 0 0.75rem;
  color: #4a4a4a;
  text-decoration: none;
  height: 100%;
  margin: 0;
}

.nav-link.is-active {
  color: #7957d5 !important;
  background-color: hsl(0, 0%, 97%) !important;
}

:deep(.b-navbar-item) {
  padding: 0 !important;
  height: 100% !important;
  margin: 0 !important;
  display: flex !important;
  align-items: stretch !important;
}

:deep(.b-navbar-item .navbar-link) {
  padding: 0 !important;
  height: 100% !important;
  margin: 0 !important;
}

:deep(.b-navbar-item.is-active) {
  background-color: hsl(0, 0%, 97%) !important;
  color: #7957d5 !important;
}

:deep(.b-navbar-item.is-active:hover) {
  background-color: hsl(0, 0%, 97%) !important;
  color: #7957d5 !important;
}

:deep(.navbar) {
  min-height: 3.25rem !important;
}

:deep(.navbar-item) {
  min-height: 3.25rem !important;
}
</style>
